import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 text-gray-800 transition-colors duration-300" }

import { onMounted, onBeforeMount, onBeforeUnmount, nextTick, ref, provide } from 'vue';
import { useUserStore } from '@/stores/user';
import { getDeviceFingerprint } from '@/utils/fingerprint';
import LoginModal from '@/components/LoginModal.vue';

// 仅导入，不立即执行
import '@/assets/tech-background.js';

declare global {
  interface Window {
    initTechBackground?: () => void;
    cleanupTechBackground?: () => void;
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// 添加全局Window接口扩展声明
const userStore = useUserStore();
const showLoginModal = ref(false);
// 用于跟踪是否已经初始化过数据
const hasInitializedData = ref(false);

provide('openLoginModal', () => {
  showLoginModal.value = true;
});

// 移除深色主题设置
document.documentElement.classList.remove('dark');

onMounted(() => {
  // 确保组件挂载后初始化背景效果
  if (window.initTechBackground) {
    window.initTechBackground();
  }
});

onBeforeUnmount(() => {
  // 组件卸载前清理背景效果
  if (window.cleanupTechBackground) {
    window.cleanupTechBackground();
  }
  
  // 清理本地存储中的初始化标志
  localStorage.removeItem('app_data_initializing');
});

onBeforeMount(async () => {
  // 获取设备指纹
  const deviceId = await getDeviceFingerprint();
});

// 集中初始化所有应用数据
const initializeAppData = async () => {
  // 如果已经初始化过，则不再重复初始化
  if (hasInitializedData.value) {
    return;
  }
    
  try {
    localStorage.setItem('app_data_initializing', 'true');
    
    // 并行加载所有需要的数据
    await Promise.all([
      userStore.fetchUserInfo(),
    ]);
    
    // 设置已初始化标志
    hasInitializedData.value = true;
    
    // 移除加载状态标志
    localStorage.removeItem('app_data_initializing');
  } catch (error) {
    localStorage.removeItem('app_data_initializing');
  }
};

// 恢复用户会话 - 在DOM加载完成后执行
onMounted(async () => {  
  // 使用nextTick确保DOM完全加载后再进行认证检查
  nextTick(async () => {
    if (userStore.isAuthenticated && !hasInitializedData.value) {
      await initializeAppData();
    }
  });
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"tech-background\"><div class=\"absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-100\"></div><div class=\"grid-overlay\"></div><div class=\"floating-particles\"></div><div class=\"light-beam\"></div></div>", 1)),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath
    }, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_KeepAlive, null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], 1024))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })),
    _createVNode(LoginModal, {
      modelValue: showLoginModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showLoginModal).value = $event))
    }, null, 8, ["modelValue"])
  ]))
}
}

})